<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
          <!-- v-if="params.context.parentComponent.permissions.change" -->
        <PrimaryButton
          @click="regenerateItem"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-autorenew"
          iconClass=""
        >
        </PrimaryButton>
      </template>
      <span>Regenerate Token</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    regenerateItem() {
      this.params.context.parentComponent.regenerateApiToken();
    },
  },
};
</script>

